import { render, staticRenderFns } from "./scopeFore.vue?vue&type=template&id=037f5bee&scoped=true&"
import script from "./scopeFore.vue?vue&type=script&lang=js&"
export * from "./scopeFore.vue?vue&type=script&lang=js&"
import style0 from "./scopeFore.vue?vue&type=style&index=0&id=037f5bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f5bee",
  null
  
)

export default component.exports